module.exports = __webpack_public_path__ + "static/media/owl.39c5abd2.jpg";